var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIconPrimary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 59728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_5665",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 55,
    height: 55
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 4131",
    d: "M0 0H54.666V54.665H0V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_5665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 59728_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 4129",
    d: "M27.334 0.470971C29.3842 0.467365 31.414 0.877547 33.302 1.67696C35.1236 2.44632 36.7785 3.56195 38.175 4.96197C39.575 6.35841 40.6907 8.01336 41.46 9.83497C42.2594 11.7229 42.6696 13.7528 42.666 15.803C42.6696 17.8532 42.2594 19.883 41.46 21.771C40.6906 23.5926 39.575 25.2475 38.175 26.644C36.7785 28.044 35.1236 29.1596 33.302 29.929C31.4142 30.7291 29.3843 31.1399 27.334 31.137C25.2838 31.1406 23.2539 30.7304 21.366 29.931C19.5444 29.1616 17.8894 28.046 16.493 26.646C15.093 25.2495 13.9773 23.5946 13.208 21.773C12.4082 19.8841 11.998 17.8532 12.002 15.802C11.9988 13.7528 12.409 11.724 13.208 9.83697C13.9773 8.01535 15.0929 6.36041 16.493 4.96397C17.8894 3.56395 19.5444 2.44833 21.366 1.67898C23.2538 0.878875 25.2836 0.467998 27.334 0.470971ZM27.334 27.804C30.5154 27.8 33.5653 26.5345 35.8149 24.2849C38.0645 22.0353 39.33 18.9854 39.334 15.804C39.33 12.6226 38.0645 9.57264 35.8149 7.32307C33.5653 5.07349 30.5154 3.80795 27.334 3.80398C24.1526 3.80795 21.1027 5.07349 18.8531 7.32307C16.6035 9.57264 15.338 12.6226 15.334 15.804C15.338 18.9854 16.6035 22.0353 18.8531 24.2849C21.1027 26.5345 24.1526 27.8 27.334 27.804Z",
    fill: "url(#paint0_linear_1_5665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 4130",
    d: "M48.26 54.1959H6.40598C4.83222 54.194 3.32345 53.568 2.21064 52.4552C1.09782 51.3424 0.47183 49.8336 0.469977 48.2599V44.3099C0.468204 42.559 0.839782 40.8279 1.55988 39.232C2.27998 37.6361 3.33208 36.2121 4.646 35.0549C7.24906 32.8474 10.2413 31.1453 13.469 30.0359C17.9283 28.5029 22.6179 27.7476 27.333 27.8029C27.5518 27.8029 27.7685 27.846 27.9706 27.9298C28.1728 28.0136 28.3564 28.1364 28.511 28.2913C28.6657 28.4461 28.7883 28.6299 28.8718 28.8321C28.9554 29.0343 28.9983 29.2511 28.998 29.4699C28.998 29.9115 28.8226 30.335 28.5103 30.6472C28.1981 30.9595 27.7746 31.1349 27.333 31.1349C15.439 31.1349 9.042 35.6269 6.844 37.5579C5.88577 38.4025 5.1186 39.4416 4.5937 40.6061C4.06879 41.7706 3.79822 43.0336 3.79999 44.3109V48.2619C3.80079 48.9528 4.07561 49.6152 4.56415 50.1037C5.0527 50.5923 5.71507 50.8671 6.40598 50.8679H48.26C48.9509 50.8671 49.6133 50.5923 50.1018 50.1037C50.5904 49.6152 50.8652 48.9528 50.866 48.2619V44.3099C50.8678 43.0326 50.5972 41.7696 50.0723 40.6051C49.5474 39.4406 48.7802 38.4015 47.822 37.5569C46.152 36.1265 44.2755 34.9566 42.256 34.0869C42.0559 33.9981 41.8753 33.8707 41.7246 33.712C41.5738 33.5533 41.4558 33.3664 41.3773 33.1621C41.2988 32.9578 41.2614 32.74 41.2672 32.5211C41.273 32.3023 41.3218 32.0868 41.411 31.8869C41.4998 31.6868 41.6272 31.5062 41.7859 31.3555C41.9446 31.2047 42.1314 31.0867 42.3358 31.0082C42.5401 30.9297 42.7579 30.8923 42.9767 30.8981C43.1955 30.9038 43.4111 30.9527 43.611 31.0419C45.9384 32.0479 48.1002 33.4002 50.023 35.0529C51.3369 36.2101 52.389 37.6341 53.1091 39.23C53.8292 40.8259 54.2008 42.557 54.199 44.3079V48.2589C54.1974 49.8333 53.5711 51.3428 52.4576 52.4559C51.3441 53.569 49.8344 54.1948 48.26 54.1959Z",
    fill: "url(#paint1_linear_1_5665)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5665",
    x1: 27.334,
    y1: 0.470947,
    x2: 27.334,
    y2: 31.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4584E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CC19C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_5665",
    x1: 27.3345,
    y1: 27.8,
    x2: 27.3345,
    y2: 54.1959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4584E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CC19C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconPrimary);
export default __webpack_public_path__ + "static/media/user-icon-primary.bdc5d3dba08154534af2ef92b5dc7ffb.svg";
export { ForwardRef as ReactComponent };